module.exports = __webpack_public_path__ + "img/yujingbtns_sel.6b481339.png";